import React, { useState } from 'react';
import { Copy } from 'lucide-react';

/**
 * Post-submit screen — full mode shows a copyable credentials block;
 * assisted mode shows a "handover email sent" confirmation.
 */
export const CredentialsSheet = ({ result, onDone }) => {
  const [copied, setCopied] = useState(false);

  if (result.mode === 'assisted') {
    return (
      <main className="main admin-page">
        <div className="topbar">
          <div>
            <h2>Handover email sent</h2>
            <div className="sub">The owner can now sign in and finish setup themselves.</div>
          </div>
        </div>
        <div className="body">
          <div className="panel" style={{ padding: 24, maxWidth: 640 }} data-testid="wiz-assisted-done">
            <div className="cred-box">
              <b>Shop created:</b> {result.subdomain}.instacut.co.uk<br />
              <b>Owner:</b> {result.email_sent ? '✓ email sent' : '✗ email failed'}
              {result.email_error && <div style={{ color: 'var(--red)' }}>Email error: {result.email_error}</div>}
              <div style={{ color: 'var(--text-mute)', fontSize: 'var(--fs-sm)', marginTop: 6 }}>Credentials sent by email. Customer booking SMS is enabled per shop on the master-admin Dashboard.</div>
            </div>
            <button className="btn p" onClick={onDone} data-testid="wiz-done">Go to shop</button>
          </div>
        </div>
      </main>
    );
  }

  const text = ((r) => {
    const lines = [
      `Instacut — new shop credentials`,
      `Shop:      ${r.subdomain}.instacut.co.uk`,
      ``,
      `Owner`,
      `  Name:     ${r.owner.name}`,
      `  Email:    ${r.owner.email}`,
      `  Password: ${r.owner.password}`,
    ];
    const withLogins = (r.barbers || []).filter((b) => b.credentials);
    if (withLogins.length) {
      lines.push('', 'Barbers with logins');
      withLogins.forEach((b) => {
        lines.push(`  ${b.name}`);
        lines.push(`    Email:    ${b.credentials.email}`);
        lines.push(`    Password: ${b.credentials.password}`);
      });
    }
    return lines.join('\n');
  })(result);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_e) { /* ignore */ }
  };

  return (
    <main className="main admin-page">
      <div className="topbar">
        <div>
          <h2>Shop created</h2>
          <div className="sub">Copy these credentials now — nothing was emailed or texted.</div>
        </div>
      </div>
      <div className="body">
        <div className="panel" style={{ padding: 24, maxWidth: 640 }} data-testid="wiz-credentials">
          <pre className="mono" style={{ whiteSpace: 'pre-wrap', fontSize: 'var(--fs-base)', background: 'var(--paper)', padding: 16, borderRadius: 8, border: '1px solid var(--line)' }}>
{text}
          </pre>
          <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
            <button className="btn p" onClick={copy} data-testid="wiz-copy-credentials">
              <Copy size={14} /> {copied ? 'Copied!' : 'Copy credentials'}
            </button>
            <button className="btn s" onClick={onDone} data-testid="wiz-done">Go to shop</button>
          </div>
        </div>
      </div>
    </main>
  );
};
